import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postControlledProduct } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_PRODS.POST,
  api: postControlledProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlledProducts/PostAction.js